import { Plan, PlanPrice, CorePlanTier, PrepaidCreditPack } from "../types";

export const CORE_PLAN_TIERS: CorePlanTier[] = [
    {
        credits: 15,
        monthlyPrice: 99,
        annualPrice: 79,
        monthlyDiscountPercent: 0,
        annualDiscountPercent: 0,
        isDefaultForPersonalUsers: true
    },
    {
        credits: 50,
        monthlyPrice: 229,
        annualPrice: 199,
        monthlyDiscountPercent: 8,
        annualDiscountPercent: 15,
        isDefault: true
    },
    {
        credits: 100,
        monthlyPrice: 399,
        annualPrice: 359,
        monthlyDiscountPercent: 12,
        annualDiscountPercent: 18
    },
    {
        credits: 200,
        monthlyPrice: 729,
        annualPrice: 669,
        monthlyDiscountPercent: 15,
        annualDiscountPercent: 20
    }
];

const defaultCoreTier = CORE_PLAN_TIERS.find((t) => t.isDefault) || CORE_PLAN_TIERS[0];

export const PLAN_PRICING: Record<Plan, PlanPrice> = {
    [Plan.Public]: { monthly: "Free", annual: "Free" },
    [Plan.UbpBasic]: { monthly: 65, annual: 49 },
    [Plan.UbpCore]: { monthly: defaultCoreTier.monthlyPrice, annual: defaultCoreTier.annualPrice },
    [Plan.UbpGrowth]: { monthly: 399, annual: 299 },
    [Plan.UbpPremiumTrial]: { monthly: 399, annual: 299 },
    [Plan.EnterpriseGrowth]: { monthly: "Custom Pricing", annual: "Custom Pricing" },
    [Plan.Enterprise]: { monthly: "Custom Pricing", annual: "Custom Pricing" },
    [Plan.LegacySandbox]: { monthly: "Free", annual: "Free" },
    [Plan.LegacyStarter]: { monthly: 249, annual: 200 },
    [Plan.Research]: { monthly: "Free", annual: "Free" },
    [Plan.UninitalizedWorkspace]: { monthly: "N/A", annual: "N/A" }
} as any;

// Prepaid credit packs — Phase IV
// Prices are placeholders from PRD, pending final approval from Brad/Lake
// totalPrice = credits * pricePerCredit (must always match)
export const PREPAID_CREDIT_PACKS: Record<"core" | "public", PrepaidCreditPack[]> = {
    core: [
        { credits: 15, totalPrice: 60, pricePerCredit: 4.0, discountPercent: 0 },
        { credits: 50, totalPrice: 185, pricePerCredit: 3.7, discountPercent: 7.5 },
        { credits: 100, totalPrice: 352, pricePerCredit: 3.52, discountPercent: 12 },
        { credits: 200, totalPrice: 682, pricePerCredit: 3.41, discountPercent: 15 },
        { credits: 600, totalPrice: 1992, pricePerCredit: 3.32, discountPercent: 17 }
    ],
    public: [
        { credits: 15, totalPrice: 60, pricePerCredit: 4.0, discountPercent: 0 },
        { credits: 50, totalPrice: 190, pricePerCredit: 3.8, discountPercent: 5 },
        { credits: 100, totalPrice: 372, pricePerCredit: 3.72, discountPercent: 7 },
        { credits: 200, totalPrice: 728, pricePerCredit: 3.64, discountPercent: 9 },
        { credits: 600, totalPrice: 2136, pricePerCredit: 3.56, discountPercent: 11 }
    ]
};
